import * as recallApi from '@otter-ai/recall-client';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { MINUTE_MS } from '@/constants/time';
import type { Subscription } from '@/shared/types/common';
import type { AdditionalQueryOptions } from '@/shared/utils/queryCreators';
import { userProfileQueryCreator } from './userProfileQueryCreator';

const queryKey = ['subscription'];

export type SubscriptionQuery = {
  readonly queryFn: (context: QueryFunctionContext) => Promise<Subscription>;
  readonly queryKey: (string | undefined)[];
  readonly staleTime: number;
};

type AdditionalSubscriptionQueryOptions = Omit<
  AdditionalQueryOptions<Subscription, typeof queryKey>,
  'staleTime'
>;

export function subscriptionQuery(
  additionalOptions: AdditionalSubscriptionQueryOptions = {},
): SubscriptionQuery {
  return {
    queryKey: queryKey,
    queryFn: async ({ client }: QueryFunctionContext) => {
      const user = await client.fetchQuery(userProfileQueryCreator());
      if (!user) {
        throw new SubscriptionQueryMissingUserError();
      }
      const response = await recallApi.getSubscription({
        query: {
          userid: user.userid.toString(),
          payment_details: true,
          subscription_history: true,
        },
        throwOnError: true,
      });
      return response.data.subscription;
    },
    staleTime: 15 * MINUTE_MS,
    ...additionalOptions,
  };
}

class SubscriptionQueryMissingUserError extends Error {
  name = 'SubscriptionQueryMissingUserError';
  message = 'User is missing for fetching subscription';
}
